import React from "react";
import { Table } from "react-bootstrap";
import ToggleBar from "../../commoncomponents/toggleBar";
import { utcToReportDate } from "../../../utils/dateConvert";
import { downloadCSVFile } from "../../../api/apiClient";
import { formatTemperatureReading, sanitizeTemperatureReadings, temperatureReadingClass } from "../../../utils/temperature";

function TemperatureExceptions(props) {
	let tempBEnabled = props.tempBEnabled;
	let tempAEnabled = props.tempAEnabled;
	let assetName = props.assetCustomerName;
	let assetId = props.assetId;
	let timeZone = props.calendarSelectedDate
		? props.calendarSelectedDate.toString().slice(25, 55)
		: "";

	const data = (
		<React.Fragment>
			<span class="text-danger">
				Temp A Threshold: <strong>{props.temperatureAThreshold}</strong>
			</span>
			<br />
			<span class="text-primary">
				Temp B Threshold: <strong>{props.temperatureBThreshold}</strong>
			</span>
			<Table responsive striped>
				<thead>
					<tr>
						<th>Exception ID</th>
						<th>Type</th>
						<th>Started</th>
						<th>Completed</th>
						<th>Duration</th>
						<th>Trip ID (Trigger)</th>
						{tempAEnabled && <th>Temp A (Trigger)</th>}
						{tempBEnabled && <th>Temp B (Trigger)</th>}
						<th>Fridge (Trigger)</th>
						{tempAEnabled && <th>Temp A (End)</th>}
						{tempBEnabled && <th>Temp B (End)</th>}
						<th>Fridge (End)</th>
					</tr>
				</thead>
				<tbody>
					{props.reportDetail.map((item, index) => {
						return (
							<tr key={index}>
								<td>{++index}</td>
								<td>{item.type}</td>
								<td>{utcToReportDate(item.started)}</td>
								<td>{utcToReportDate(item.completed)}</td>
								<td>{item.duration}</td>
								<td>{item.tripId}</td>
								{tempAEnabled && <td className={temperatureReadingClass(item.tempAStart)}>{formatTemperatureReading(item.tempAStart)}</td>}
								{tempBEnabled && <td className={temperatureReadingClass(item.tempBStart)}>{formatTemperatureReading(item.tempBStart)}</td>}
								<td>{item.fridgeStart ? "On" : "Off"}</td>
								{tempAEnabled && <td className={temperatureReadingClass(item.tempAEnd)}>{formatTemperatureReading(item.tempAEnd)}</td>}
								{tempBEnabled && <td className={temperatureReadingClass(item.tempBEnd)}>{formatTemperatureReading(item.tempBEnd)}</td>}
								<td>{item.fridgeEnd ? "On" : "Off"}</td>
							</tr>
						);
					})}
				</tbody>
			</Table>
		</React.Fragment>
	);

	const handleDownloadExcel = () => {
		downloadCSVFile(
			props.reportDetail.map(sanitizeTemperatureReadings),
			"TempException",
			assetName,
			timeZone,
			assetId
		);
	};

	return (
		<ToggleBar
			caption="Temperature Exceptions"
			download={handleDownloadExcel}
			icon="fa-thermometer-half"
			color="#337AB7"
			content={data}
		/>
	);
}

export default TemperatureExceptions;
